import { Component, OnInit } from '@angular/core';
import {
  AdminScopes,
  AdminUser,
  UserService,
} from '@app/shared/services/user.service';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-site-tours',
  templateUrl: './site-tours.component.html',
})
export class SiteToursComponent implements OnInit {
  public isLoading: boolean = true;
  public canEdit: boolean = false;
  public CDN_URL: string = environment.CDN_URL;
  public user: AdminUser;

  public selectedTab: number = 0;
  public tabs = [
    {
      label: 'Site Tours',
      id: 'app-list-site-tours',
      scope: [AdminScopes.VIEW_SITE_TOURS],
    },
    {
      label: 'Hotspots',
      id: 'app-list-hotspots',
      scope: [AdminScopes.VIEW_SITE_TOURS],
    },
  ];

  constructor(
    private userService: UserService,
    private router: Router,
  ) {}
  ngOnInit() {
    this.isLoading = true;
    this.userService
      .getAuthenticatedUser([AdminScopes.VIEW_SITE_TOURS])
      .pipe(first())
      .subscribe(
        (adminUser: AdminUser) => {
          if (adminUser) {
            this.user = adminUser;
            this.canEdit = this.userService.hasAuthScope(this.user, [AdminScopes.MODIFY_SITE_TOURS]);
            this.isLoading = false;
          } else {
            this.router.navigate(['login']);
          }
        },
        (err) => {
          this.router.navigate(['home']);
        }
      );
  }
}
